import React, { useState } from "react"
import { LuNotebookPen } from "react-icons/lu"
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap"
import apiHandler from "../../common/config/apiHandler"
import { toast } from "react-hot-toast"
import Loader from "../../components/Loader/loader"
import moment from "moment"

const SeeNotes = ({ Booking_ID, BookingNote }) => {
  const [show, setShow] = useState(false)
  const [notes, setNotes] = useState(null)
  const [loading, setLoading] = useState(false)

  const handleShow = async () => {
    setShow(true)
    setLoading(true)
    try {
      const response = await apiHandler({
        endpoint: `/backend/bookingnote/${Booking_ID}`,
        method: "GET",
      })

      if (response?.code === 200) {
        setNotes(response.data)
      }
    } catch (error) {
      toast.error("Something went wrong while fetching notes.")
      console.error("Error fetching notes:", error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      {BookingNote?.length > 0 && (
        <>
          <div className="position-relative " style={{ left: "-3px" }}>
            <span
              className="position-absolute  start-100 translate-middle badge rounded-circle bg-primary text-white"
              style={{ marginTop: "-5px", marginLeft: "9px", top: "7px", width: '13px' }}

            >
              {BookingNote.length}
            </span>

            <LuNotebookPen
              style={{ width: "14px", cursor: "pointer" }}
              className="text-black mx-1 mt-1"
              size={20}
              onClick={handleShow}
            />
          </div>
        </>
      )}

      <Modal isOpen={show} toggle={() => setShow(false)}>
        <ModalHeader toggle={() => setShow(false)}>Booking Notes</ModalHeader>
        <ModalBody className="" style={{ height: "300px", overflowY: "auto" }}>
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100px",
              }}
            >
              <Loader />
            </div>
          ) : notes && notes.length > 0 ? (
            notes.map((note, index) => (
              <div key={index} className="mb-1 shadow p-2 border rounded ">
                <div className="d-flex  justify-content-between">
                  <h6 className="fw-bold text-primary text-capitalize">
                    {note?.users?.first_name}
                  </h6>
                  <h6 className="text-dark  fw-bold ">
                    {note?.createdAt
                      ? moment(note.createdAt)
                        .tz("Europe/London")
                        .format("DD-MM-YYYY HH:mm:ss")
                      : "No Date"}
                  </h6>
                </div>
                <p className=" text-muted">
                  {note?.note || "No description available."}
                </p>
              </div>
            ))
          ) : (
            <p className="text-muted">No notes available.</p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={() => setShow(false)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default SeeNotes
